import React, { useEffect, useState } from "react";
import { Alert, Button, Card, Col, Modal, Result, Row, Skeleton, Typography } from "antd";
import { StudentUser } from "interfaces/users";
import axios from "axios";
import { useHistory, useParams } from "react-router-dom";
import { StudyProgram } from "interfaces/students";
import { message } from "components/Messages/Messages";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope, faGraduationCap, faPhone, faStairs } from "@fortawesome/free-solid-svg-icons";
import { NoShow } from "interfaces/events";
import StudentInfo from "./Sections/StudentInfo";
import Log from "./Sections/Log";
import EditStudent from "./Sections/EditStudent";
import NoShows from "./Sections/NoShows";
import CreateTermViolation from "./Sections/CreateTermViolation";

const { Title, Text } = Typography;

const AdminSingleStudent = () => {
  const [student, setStudent] = useState<StudentUser>();
  const { id } = useParams<{ id: string }>();
  const [studyProgram, setStudyProgram] = useState<StudyProgram>();
  const [loading, setLoading] = useState<boolean>(true);
  const [loadingDelete, setLoadingDelete] = useState<boolean>(false);
  const [editingStudent, setEditingStudent] = useState<boolean>(false);
  const [newTermViolation, setNewTermViolation] = useState<NoShow>();

  const history = useHistory();

  useEffect(() => {
    setLoading(true);
    axios
      .get<StudentUser>(`/students/${id}/`)
      .then(response => {
        setStudent(response.data);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, [id]);

  useEffect(() => {
    if (!student || !student.study_programme) return;
    axios.get<StudyProgram>(`/students/study-program/${student?.study_programme}/`).then(response => {
      setStudyProgram(response.data);
    });
  }, [student]);

  if (loading) return <Skeleton active />;
  if (!student)
    return <Result title="Fant ikke studenten" subTitle="Dobbeltsjekk URL eller prøv på nytt" status="404" />;

  const deleteStudent = () => {
    Modal.confirm({
      title: "Er du sikker på at du vil slette studenten?",
      content: "Denne handlingen kan ikke angres",
      okText: "Slett",
      okType: "danger",
      cancelText: "Avbryt",
      type: "error",
      onOk() {
        setLoadingDelete(true);
        axios
          .delete(`/students/${id}/`)
          .then(() => {
            message("success", "Studenten ble slettet");
            history.push("/admin/students/");
            setLoadingDelete(false);
          })
          .catch(() => {
            message("error", "Feil ved sletting av student");
            setLoadingDelete(false);
          });
      },
    });
  };

  return (
    <>
      {student.has_graduated && (
        <Alert
          message="Denne studenten er uteksaminert fra NTNU"
          type="error"
          style={{
            marginBottom: 16,
          }}
        />
      )}
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <Card>
            <Title level={2}>{`${student.first_name} ${student.last_name}`}</Title>
            <Row gutter={15}>
              <Col>
                <FontAwesomeIcon icon={faGraduationCap} />
                <Text style={{ padding: ".5em" }}>{studyProgram?.name}</Text>
              </Col>
              <Col>
                <FontAwesomeIcon icon={faStairs} />
                <Text style={{ padding: ".5em" }}>{student.year_level}. klasse</Text>
              </Col>
              <Col>
                <FontAwesomeIcon icon={faEnvelope} />
                <Text style={{ padding: ".5em" }}>{student.email}</Text>
              </Col>
              <Col>
                <FontAwesomeIcon icon={faPhone} />
                <Text style={{ padding: ".5em" }}>{student.mobile_number}</Text>
              </Col>
            </Row>
          </Card>
        </Col>
        <Col xs={24} md={8}>
          <Row gutter={[16, 16]}>
            <Col span={24}>
              <StudentInfo student={student} newTermViolation={newTermViolation} />
            </Col>
            <Col span={24}>
              <CreateTermViolation
                student={student}
                onSuccess={(noShow: NoShow) => {
                  setNewTermViolation(noShow);
                }}
              />
            </Col>
          </Row>
        </Col>
        <Col md={16}>
          <Row gutter={[16, 16]}>
            <Col span={24}>
              <Row gutter={[16, 10]} justify="space-between">
                <EditStudent
                  student={student}
                  isOpen={editingStudent}
                  onSave={s => {
                    setStudent(s);
                    setEditingStudent(false);
                  }}
                  onClose={() => setEditingStudent(false)}
                />
                <Col sm={24} lg={8}>
                  <Button style={{ width: "100%" }} type="primary" onClick={() => setEditingStudent(true)}>
                    Rediger student
                  </Button>
                </Col>
                <Col sm={24} lg={8}>
                  <Button style={{ width: "100%" }}>Logg inn som {student.first_name}</Button>
                </Col>
                <Col sm={24} lg={8}>
                  <Button
                    style={{ width: "100%" }}
                    type="primary"
                    danger
                    onClick={deleteStudent}
                    loading={loadingDelete}
                  >
                    Slett student
                  </Button>
                </Col>
              </Row>
            </Col>
            <Col span={24}>
              <Row gutter={[16, 16]}>
                <Col span={24}>
                  <Log
                    studentId={Number(id)}
                    onTermViolationCreated={(noShow: NoShow) => {
                      setNewTermViolation(noShow);
                    }}
                  />
                </Col>
                <Col span={24}>
                  <NoShows studentId={Number(id)} newTermViolation={newTermViolation} />
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
};

export default AdminSingleStudent;
